import isCompositeImage from '../../common/helpers/is-composite-image';
import isSingleFullWidthColumnInWidget from '../../common/helpers/is-single-full-width-column-in-widget';

const IMAGE_WIDGET_SELECTOR = 'ws-block[widget="image"]';
const VIDEO_WIDGET_SELECTOR = 'ws-block[widget="video"]';
const COLUMN_WIDGET_SELECTOR = 'ws-block[widget="columns"]';

const imageWidgetsToSkip = [IMAGE_WIDGET_SELECTOR, VIDEO_WIDGET_SELECTOR];
const widgetsToSkip = [COLUMN_WIDGET_SELECTOR];

const shouldSkipSameBoundsElement = (sourceElement, element) => {
  if (isSingleFullWidthColumnInWidget(sourceElement)) {
    return true;
  }

  if (sourceElement.matches(widgetsToSkip)) {
    return true;
  }

  // Skip image widgets with composite images
  if (element.matches(imageWidgetsToSkip) && isCompositeImage(sourceElement)) {
    return true;
  }

  return false;
};

export default shouldSkipSameBoundsElement;
